import { useMemo } from 'react';
import useGetProjectFieldsets from './useGetProjectFieldsets';

const useGetFieldServiceCustomFields = () => {
  const { projectFieldsets, ...rest } = useGetProjectFieldsets();

  const data = useMemo(
    () => projectFieldsets?.filter((f) => f.fieldServiceSelfAssignable),
    [projectFieldsets]
  );

  return { data, ...rest };
};

export default useGetFieldServiceCustomFields;
